module.exports = __webpack_public_path__ + "static/media/default_image.c0eb1872.svg";